import { render, staticRenderFns } from "./ProjectPopover.vue?vue&type=template&id=6281a7a1&"
import script from "./ProjectPopover.vue?vue&type=script&lang=js&"
export * from "./ProjectPopover.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPopover.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProjectPopover.vue"
export default component.exports